import React from "react";
import MiniDrawer from "../../components/Drawer"
import MyTeamGrid from "../../components/MyTeam"

const MyTeam = () => {
    return (
        <MiniDrawer child={<MyTeamGrid />} />
    )
}

export default MyTeam
